import React, { useState } from "react";
import { api } from "@/lib/apiClient";
import { toast } from "sonner";
import { Mail } from "lucide-react";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Please add your email.");
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Thank you — you're on the list.");
      setEmail("");
    } catch {
      toast.error("Something went wrong. Try again?");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="lf-container py-20 md:py-28" data-testid="newsletter-section">
      <div
        className="relative overflow-hidden p-10 md:p-16 grid grid-cols-1 md:grid-cols-12 gap-10 items-center"
        style={{ background: "var(--lf-pink-pale)", borderRadius: 28 }}
      >
        <div
          className="lf-blob lf-blob-mint hidden md:block"
          style={{ width: 180, height: 180, top: -40, right: -40, opacity: 0.5 }}
        />
        <div
          className="lf-blob lf-blob-gold hidden md:block"
          style={{ width: 70, height: 70, bottom: 20, left: 30, opacity: 0.35 }}
        />

        <div className="md:col-span-7 relative">
          <span className="lf-eyebrow">Stay in bloom</span>
          <h2
            className="font-serif mt-3 leading-[0.95]"
            style={{
              fontSize: "clamp(2rem, 4.5vw, 3.5rem)",
              fontWeight: 300,
              color: "var(--lf-ink)",
            }}
          >
            Subscribe for new
            <br />
            <em style={{ color: "var(--lf-gold-deep)" }}>arrivals & florist tips.</em>
          </h2>
          <p className="mt-4 text-base md:text-lg" style={{ color: "var(--lf-ink-soft)" }}>
            Same-day delivery alerts, seasonal collections, and the occasional secret sale.
          </p>
        </div>

        <form onSubmit={submit} className="md:col-span-5 flex flex-col gap-3 relative" data-testid="newsletter-form">
          <label className="lf-eyebrow flex items-center gap-2" htmlFor="newsletter-email">
            <Mail size={14} /> Your email
          </label>
          <input
            id="newsletter-email"
            data-testid="newsletter-email"
            type="email"
            className="lf-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@example.com"
          />
          <button type="submit" disabled={loading} className="lf-btn lf-btn-gold mt-1 justify-center" data-testid="newsletter-submit">
            {loading ? "Subscribing…" : "Subscribe"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;
